import { AppErrorBoundary } from '@pm/core';
import { ReactNode, useEffect } from 'react';
import { useSupportLinks } from '../hooks/use-support-links';
import Header from '../layouts/MainAppLayout/Header';

const CA_SUPPORT_LINK = 'https://help.gofreddie.com/hc/en-us/requests/new';

let supportLink = CA_SUPPORT_LINK;

// useSupportLinks requires patient profile context
// wrapping, which means we cannot use the reusable core
// component directly.
export const FreddieAppErrorBoundary = ({
  children,
}: {
  children: ReactNode;
}) => (
  <AppErrorBoundary header={<Header />} contactSupportLink={supportLink}>
    {children}
  </AppErrorBoundary>
);

export const SyncSupportLink = () => {
  const { zendesk } = useSupportLinks();
  useEffect(() => {
    supportLink = zendesk.newRequest;
  }, [zendesk.newRequest]);
  return null;
};
